// extracted by mini-css-extract-plugin
export default {"canvas":"mochi-sparkles_canvas__SFFm5"};